
const VisionStatement = () => {
  return (
    <div className="bg-no-repeat  bg-AdviceBg font-[Inter] bg-cover relative sm:mx-14">
      <div className="absolute inset-0 bg-[#02041ccf] "></div>
      <div className="relative z-10">
      <div className=" transform p-6 sm:p-20 flex flex-col items-center gap-8 text-white text-center">
        <div className="h-1 w-14 bg-[#004C97] sm:mb-5"></div>
        <h2 className="font-bold sm:text-7xl leading-[0.4] sm:leading-5 text-6xl font-[Tangerine]">
          Vision <br /> Statement
        </h2>
        <p className="text-sm sm:w-[50%] sm:mx-auto">
          To make Quranic recitation and memorization accessible to every Muslim
          worldwide, ensuring they master multiple Qira’at and maintain an
          unbroken chain of transmission (Isnad) back to the Prophet Muhammad
          (PBUH).
        </p>
      </div>
      </div>
    </div>
  );
};

export default VisionStatement;
